import { dollars } from "../../lib/formatters/currency";

export const displaySrp = (renderDummyValues, inventory) => {
  if (inventory.mod_to && inventory.mod_to.id !== inventory.part.id) {
    return "MOD";
  }

  return (
    inventory.suggested_retail &&
    dollars(
      renderDummyValues
        ? inventory.dummy.suggested_retail || inventory.suggested_retail
        : inventory.suggested_retail
    )
  );
};



// WEBPACK FOOTER //
// ./app/modules/parts/helpers.js